module.exports = __webpack_public_path__ + "img/15.6dd657b4.jpg";